module.exports = __webpack_public_path__ + "img/option_icon.27ec9f8e.svg";